export default {
   setWorkers: (state,payload) => {
      state.workers = payload;
   },
}